module.exports = __webpack_public_path__ + "static/media/i-like-to-watch.30d806fe.jpg";